import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Result from './Result';
import useScrollPositioning from './useScrollPositioning';
import classnames from 'classnames';
import renderIf from 'render-if';
import Spinner from '../common/Spinner';
import AccountSearchAiChatCta from './AccountSearchAiChat/AccountSearchAiChatCta';

// Global cache because we only expect to have one of these on a page at any given time.
// This helps us mount & unmount the component with the same state.
const newCache = () => {
  return {
    recentViews: [],
    pageVisitsSinceCached: 0,
    scroll: {
      top: 0,
      query: null,
    },
  };
};

$(document).on('page:load drawer:load', () => {
  cache.pageVisitsSinceCached++;

  if (cache.pageVisitsSinceCached > 1) {
    cache.recentViews = [];
  }
});

let cache = newCache();
document.addEventListener('aha.fred.error', () => {
  cache = newCache();
});

const RecentViews = ({ query }) => {
  const [recentViews, setRecentViews] = useState(cache.recentViews);
  const [loadingResults, setLoadingResults] = useState(false);

  useEffect(() => {
    let cancelFetch = false;

    if (cache.recentViews.length === 0) setLoadingResults(true);
    $.ajax({
      url: `/recent_views`,
      type: 'GET',
      dataType: 'json',
    }).then(response => {
      if (cancelFetch) return;
      cache.recentViews = response;
      setLoadingResults(false);
      setRecentViews(response);
    });

    return () => {
      cancelFetch = true;
    };
  }, [setLoadingResults]);

  useEffect(() => {
    const resultSelected = event => {
      const result = event.detail.result;
      const position = recentViews.indexOf(result);
      cache.recentViews.splice(position, 1);
      cache.recentViews.unshift(result);
      cache.pageVisitsSinceCached = 0; // reset counter so we only show loaders if needed
      return false;
    };

    document.addEventListener('aha.fred.result-selected', resultSelected);
    return () => {
      document.removeEventListener('aha.fred.result-selected', resultSelected);
    };
  }, [recentViews]);

  const { setScroll, resultsRef } = useScrollPositioning({
    cache,
    query,
    fetchMore: null,
  });

  const filterAssistantEnabled =
    window.featureFlags?.search_filters_ai_assistant &&
    window.currentAccount?.aiAnalysisOfSearchResultsEnabled &&
    !window.currentAccount?.onlyDiscoveryFlavor;

  return (
    <div className='search'>
      <div
        className={classnames({
          results: true,
          'results--loading': loadingResults,
        })}
        ref={resultsRef}
        onScroll={e => {
          setScroll(e.target.scrollTop);
        }}
      >
        {renderIf(loadingResults)(<Spinner />)}

        {renderIf(!loadingResults)(
          <>
            {renderIf(!query?.length && filterAssistantEnabled)(
              <AccountSearchAiChatCta />
            )}
            {recentViews.map((result, index) => {
              return (
                <Result
                  key={result.url}
                  result={result}
                  showProject
                  timestampCopy={'Last viewed:'}
                />
              );
            })}

            {renderIf(recentViews.length === 0)(
              <div className='empty'>
                <h3>No recently viewed records</h3>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RecentViews;
